
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Punetosataracab() {



    const cardData =
    {
        keyword: 'Pune to Satara Cab',
        heading: 'Meghana Cab : Pune to Satara Cab',
        headingDescription: 'Meghana Cab offers Pune to Satara Cab services, providing a convenient, safe, and affordable travel option for your journey. Whether you are heading to Satara for sightseeing, family visits, or business purposes, our well-maintained vehicles and professional drivers ensure a smooth and timely ride. Choose from a wide range of cabs to suit your comfort and budget, and enjoy transparent pricing with no hidden charges. Book your Pune to Satara Cab with Meghana Cab and travel with ease, reliability, and peace of mind.',


        top: 'Top Places to Visit in Satara with Meghana Cab',

      "topPlaces": [
  {
    "title": "Kas Plateau",
    "description": "Also known as Kaas Pathar, this UNESCO‑recognized ‘valley of flowers’ blooms with over 850 floral species during monsoon (Aug–Sep), nestled in the Western Ghats." 
  },
  {
    "title": "Thoseghar Waterfalls",
    "description": "A breathtaking cluster of waterfalls up to ~200 m high, located ~20 km from Satara—best experienced during the rainy season with viewing platforms and serene picnic spots." 
  },
  {
    "title": "Ajinkyatara Fort",
    "description": "A historic hill fort at ~3,300 ft overlooking Satara city, featuring Maratha architecture, temples, water tanks, and moderate trekking paths." 
  },
  {
    "title": "Vajrai Waterfall",
    "description": "Also called Bhambavli Vajrai, this majestic three‑tiered waterfall on the Urmodi River plunges around 260 m and flows year‑round amid lush Sahyadri surroundings." 
  },
  {
    "title": "Pratapgad Fort",
    "description": "A prominent 1650s hill fort built by Shivaji Maharaj, offering panoramic vistas of the Konkan coast and steeped in Maratha history." 
  },
  {
    "title": "Sajjangad",
    "description": "A peaceful pilgrimage fort and the resting place of Sant Ramdas Swami, featuring daily bhajans and prasād, accessible via vehicle and a short climb." 
  },
  {
    "title": "Shri Chhatrapati Shivaji Maharaj Museum",
    "description": "Also known as Satara Museum, it displays Maratha-era artifacts—weaponry, armour, and royal memorabilia—offering cultural insight." 
  },
  {
    "title": "Sangam Mahuli & Kshetra Mahuli",
    "description": "Two sacred riverside villages with 18th–19th‑century Shiva temples, set at the confluence of the Krishna and Venna rivers." 
  },
  {
    "title": "Char Bhinti",
    "description": "A scenic viewpoint near Ajinkyatara, ideal for sunset or night‑time city lights, offering panoramic vistas across Satara and surrounding hills." 
  },
  {
    "title": "Koyna Dam",
    "description": "A major dam across the Koyna River with adjacent gardens and boat rides on Shivsagar Lake—perfect for a relaxed outing." 
  }
],

  "services": [
    {
        "name": "Pune to Satara Taxi Booking",
        "description": "Book a reliable taxi from Pune to Satara with Meghana Cab and enjoy a smooth, safe, and comfortable journey. Our service includes clean vehicles, experienced drivers, and easy online booking for a stress-free intercity travel experience."
    },
    {
        "name": "One Way Cab to Satara",
        "description": "Looking for a one-way cab to Satara from Pune? Meghana Cab provides affordable and punctual one-way taxi services with doorstep pickup, AC comfort, and courteous chauffeurs to make your travel seamless and enjoyable."
    },
    {
        "name": "Round Trip Taxi Pune to Satara",
        "description": "Plan a return journey from Pune to Satara with Meghana Cab’s round trip service. Ideal for business visits or family outings, our round-trip taxis offer flexibility, time savings, and consistent driver support throughout your journey."
    },
    {
        "name": "Budget Cabs Pune to Satara",
        "description": "Travel affordably without compromising comfort. Meghana Cab offers budget cab options for Pune to Satara travel with transparent pricing, no hidden charges, and clean, fuel-efficient cars driven by trained professionals."
    },
    {
        "name": "Pune to Satara Road Trip Cab",
        "description": "Enjoy the scenic highway between Pune and Satara in one of our comfortable road trip cabs. Meghana Cab provides well-maintained vehicles and experienced drivers to make your journey pleasant, relaxed, and memorable."
    },
    {
        "name": "AC Taxi Service to Satara from Pune",
        "description": "Beat the heat with our AC taxi service from Pune to Satara. Meghana Cab ensures every vehicle is equipped with efficient air-conditioning, clean interiors, and reclining seats to deliver a cool, calm, and refreshing ride."
    },
    {
        "name": "Outstation Cab for Satara",
        "description": "Book Meghana Cab’s outstation cab service for a smooth trip from Pune to Satara. Our intercity taxis are perfect for business meetings, weekend breaks, and family visits, ensuring punctuality and comfort across the journey."
    },
    {
        "name": "Pune to Satara Sedan Cab",
        "description": "Travel in elegance with our sedan cab options for Pune to Satara. Ideal for small groups or solo travelers, Meghana Cab offers sedans with plush seating, ample luggage space, and professional service at competitive rates."
    },
    {
        "name": "Pune to Satara SUV Hire",
        "description": "Need more room for family or group travel? Hire an SUV from Pune to Satara with Meghana Cab and enjoy spacious interiors, smooth rides, and extra legroom – perfect for long-distance comfort with safety guaranteed."
    },
    {
        "name": "Online Cab Booking Pune to Satara",
        "description": "Book your cab from Pune to Satara online in just a few clicks with Meghana Cab. Our booking system is fast, mobile-friendly, and transparent—offering real-time vehicle availability, instant confirmation, and flexible payment options."
    },
    {
        "name": "Car Hire for Satara Journey",
        "description": "Hire a car from Pune to Satara with Meghana Cab for a personalized and private travel experience. Choose your preferred vehicle, enjoy flexible pick-up times, and relax with our experienced drivers handling the route."
    },
    {
        "name": "Pune to Satara Intercity Cab",
        "description": "Meghana Cab provides dependable intercity taxi services from Pune to Satara. Whether you're traveling for work or leisure, our intercity fleet ensures timely departures, well-kept vehicles, and responsive customer service."
    },
    {
        "name": "24/7 Cab Service to Satara",
        "description": "Need a ride to Satara at any hour? Meghana Cab’s 24/7 taxi service ensures you’re never stranded. We operate around the clock with verified drivers and reliable vehicles, available anytime—day or night."
    },
    {
        "name": "Pune to Satara Cab Fare Estimate",
        "description": "Get an upfront cab fare estimate for your Pune to Satara trip with Meghana Cab. Our fare calculator gives you accurate, transparent pricing so you can plan your budget confidently—no surprises, no hidden charges."
    },
    {
        "name": "Hire Driver for Pune to Satara",
        "description": "Already have a car but need a driver? Meghana Cab provides professional chauffeur services for Pune to Satara journeys. Enjoy your own vehicle with the added comfort of a trained, local driver to guide you safely."
    }
],

"tableData": [
    ["Pune to Satara Taxi Booking", "One Way Cab to Satara"],
    ["Round Trip Taxi Pune to Satara", "Budget Cabs Pune to Satara"],
    ["Pune to Satara Road Trip Cab", "AC Taxi Service to Satara from Pune"],
    ["Outstation Cab for Satara", "Pune to Satara Sedan Cab"],
    ["Pune to Satara SUV Hire", "Online Cab Booking Pune to Satara"],
    ["Car Hire for Satara Journey", "Pune to Satara Intercity Cab"],
    ["24/7 Cab Service to Satara", "Pune to Satara Cab Fare Estimate"],
    ["Hire Driver for Pune to Satara", ""],
    ["", ""]
],







"whychoose": [
    {
        "WhyChooseheading": "Comfortable Pune to Satara Cab Service",
        "WhyChoosedescription": "Meghana Cab provides a comfortable and convenient cab service from Pune to Satara. Whether it’s for a business trip, family visit, or a weekend getaway, enjoy a smooth and stress-free journey with us."
    },
    {
        "WhyChooseheading": "On-Time Pick-Up and Drop",
        "WhyChoosedescription": "Punctuality matters. Our Pune to Satara cab service ensures timely pick-up and drop so you can reach your destination without delays, every time you travel with Meghana Cab."
    },
    {
        "WhyChooseheading": "Experienced Drivers Familiar with the Route",
        "WhyChoosedescription": "Our professional drivers have excellent knowledge of the Pune to Satara route. They ensure a safe and efficient ride, choosing the best roads to make your travel faster and more comfortable."
    },
    {
        "WhyChooseheading": "Affordable Cab Fare from Pune to Satara",
        "WhyChoosedescription": "We offer budget-friendly pricing with no hidden fees. Meghana Cab provides affordable and transparent rates for the Pune to Satara route, helping you manage your travel costs with ease."
    },
    {
        "WhyChooseheading": "Clean and Well-Maintained Vehicles",
        "WhyChoosedescription": "Travel in comfort and safety with our regularly serviced and sanitized cabs. Our fleet includes clean, air-conditioned vehicles with all essential safety features for a worry-free journey."
    },
    {
        "WhyChooseheading": "24/7 Cab Availability for Pune to Satara",
        "WhyChoosedescription": "Need to travel at odd hours? Meghana Cab operates round the clock, offering 24/7 cab service from Pune to Satara to match your travel schedule, no matter the time."
    },
    {
        "WhyChooseheading": "Flexible Travel Plans and Packages",
        "WhyChoosedescription": "We offer customizable travel options for your Pune to Satara trip. Whether it's a one-way drop, round trip, or multiple halts, we adjust to suit your specific travel needs."
    },
    {
        "WhyChooseheading": "Easy and Quick Online Booking",
        "WhyChoosedescription": "Booking your Pune to Satara cab with Meghana Cab is simple and convenient. Use our website or app for quick online reservations, or connect with our support team for assistance."
    }
]















    }

const faqData = [
    {
        question: "How can I book a Pune to Satara cab with Meghana Cab?",
        answer: "Booking a cab from Pune to Satara is simple with Meghana Cab. You can book online through our website or call us directly at +91 9075462128."
    },
    {
        question: "What cab options are available for Pune to Satara travel?",
        answer: "We offer a variety of cabs including hatchbacks, sedans, SUVs, and tempo travellers to accommodate different travel needs and group sizes."
    },
    {
        question: "Is the Pune to Satara cab available for one-way trips?",
        answer: "Yes, we provide both one-way and round-trip cab services from Pune to Satara at competitive prices."
    },
    {
        question: "How much time does it take to travel from Pune to Satara by cab?",
        answer: "The journey typically takes around 2.5 to 3 hours depending on traffic and road conditions."
    },
    {
        question: "Are there any extra charges like tolls for the Pune to Satara cab?",
        answer: "Toll, parking, and state taxes are additional and are clearly mentioned during the booking process."
    },
    {
        question: "Can I book a cab for an early morning or late-night trip from Pune to Satara?",
        answer: "Yes, Meghana Cab operates 24/7, allowing you to schedule your ride at any time of the day or night."
    },
    {
        question: "Are Meghana Cab drivers experienced for Pune to Satara trips?",
        answer: "Yes, all our drivers are professional and experienced, and they are well-acquainted with the Pune to Satara route."
    },
    {
        question: "Can I request stops during the Pune to Satara cab journey?",
        answer: "Yes, stops can be arranged on request. Please inform us in advance while booking to plan your trip better."
    },
    {
        question: "What payment methods do you accept for Pune to Satara cab bookings?",
        answer: "We accept payments via UPI, credit/debit cards, net banking, and cash for your convenience."
    },
    {
        question: "How do I contact Meghana Cab for Pune to Satara bookings?",
        answer: "You can call us at +91 9075462128 for bookings, inquiries, and support."
    }
];

const testimonialsData = [
    {
        name: 'Mr. Ajay Khandekar',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Our Pune to Satara cab journey with Meghana Cab was fantastic. The cab was neat and the driver was very polite and punctual. Will definitely book again!”',
    },
    {
        name: 'Ms. Rutuja Desai',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“I had a great experience booking a cab from Pune to Satara with Meghana Cab. The process was smooth, and the service was reliable and professional.”',
    },
];











































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Satara Cab",
  "image": "https://www.meghanacabs.com/assets/images/pune-to-satara-cab.jpg",
  "description": "Book a comfortable and affordable cab from Pune to Satara with Meghana Cabs. Available 24/7 for one-way and round trips. Choose from Sedan, SUV, and AC vehicles with expert drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Meghana Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5124"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1999",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/pune-to-satara-cab"
  }
};






    return (
        <div>

<Helmet>
  <title>Pune to Satara Cab | One Way & Round Trip Taxi | Meghana Cabs</title>
  <meta 
    name="description" 
    content="Book a comfortable and affordable cab from Pune to Satara with Meghana Cabs. Available 24/7 for one-way and round trips. Choose from Sedan, SUV, and AC vehicles with expert drivers." 
  />
  <meta 
    name="keywords" 
    content="Pune to Satara Taxi Booking, One Way Cab to Satara, Round Trip Taxi Pune to Satara, Budget Cabs Pune to Satara, Pune to Satara Road Trip Cab, AC Taxi Service to Satara from Pune, Outstation Cab for Satara, Pune to Satara Sedan Cab, Pune to Satara SUV Hire, Online Cab Booking Pune to Satara, Car Hire for Satara Journey, Pune to Satara Intercity Cab, 24/7 Cab Service to Satara, Pune to Satara Cab Fare Estimate, Hire Driver for Pune to Satara" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/3.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                             <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetosataracab;